const Faq = () =>
  import(
    /* webpackChunkName: "site-faq" */ '@/pages/site-generator/cms/faq/index.vue'
  )
const CreateFaq = () =>
  import(
    /* webpackChunkName: "site-faq" */ '@/pages/site-generator/cms/faq/create.vue'
  )
const EditFaq = () =>
  import(
    /* webpackChunkName: "site-faq" */ '@/pages/site-generator/cms/faq/edit.vue'
  )

export default {
  path: 'faq',
  meta: {
    label: 'faq',
    auth: 'faq'
  },
  component: {
    name: 'FAQ',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteFaqReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Faq
    },
    {
      name: 'SiteCreateFaq',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateFaq
    },
    {
      name: 'SiteEditFaq',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditFaq,
      props: true
    }
  ]
}
